<template>
  <div class="login-container">
    <!-- <ul class="ul">
      <li style="width:102px;background: #3176FF;color: rgba(255, 255, 255, 0.9);border-radius: 2px;">后台管理端</li>
      <li style="width: 74px;">学生端</li>
    </ul> -->
    <div class="main">
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
        <!-- <button class="into-btn" @click="toPage">进入学生端</button> -->
        <div class="right-content">
          <div style="font-size:36px;font-weight:600;color:#2C2C2C;margin-bottom:16px">{{config.loginText}}</div>
          <div style="font-size:24px;font-weight:600;color:#2C2C2C;margin-bottom:16px">后台管理端</div>
          <p style="text-align:left;color:#374151;font-weight: 600;margin-bottom:8px">账号</p>
          <el-form-item prop="account">
            <img src="../../assets/images/account.png" class="account" alt />
            <el-input
              ref="account"
              v-model="loginForm.account"
              placeholder="请输入账号"
              name="account"
              type="text"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <p style="text-align:left;color:#374151;font-weight: 600;margin-bottom:8px">密码</p>
          <el-form-item prop="password">
            <img src="../../assets/images/password.png" class="password" alt />
            <el-input
              :key="passwordType"
              ref="password"
              v-model="loginForm.password"
              :type="passwordType"
              placeholder="请输入密码"
              name="password"
              tabindex="2"
              auto-complete="on"
              @keyup.enter.native="handleLogin"
            />
            <span class="show-pwd" @click="showPwd">
              <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"  />
            </span>
          </el-form-item>
          <p style="text-align:left;color:#374151;font-weight: 600;margin-bottom:8px">验证码</p>
          <el-form-item prop="captcha">
            <el-input
              ref="captcha"
              v-model="loginForm.captcha"
              placeholder="请输入验证码"
              name="captcha"
              type="text"
              size="small"
              auto-complete="on"
              @keyup.enter.native="handleLogin"
            />
            <captcha
              ref="captchaComponent"
              :code.sync="captchaCode"
              class="captcha-img"
            />
          </el-form-item>
          <!-- <div style="text-align: left;margin-bottom:30px;">
            <el-checkbox v-model="checked">记住密码</el-checkbox>
          </div> -->
          <el-button :loading="loading" type="primary" class="btn"
            @click.native.prevent="handleLogin"
            @keyup.enter.native="handleLogin">登录</el-button>
          <!-- <p style="color:#fff">登录即表示您同意
            <a href="javascript:void(0)" style="color:#3176FF">服务条款</a>
            和
            <a href="javascript:void(0)" style="color:#3176FF">隐私政策</a>
          </p> -->
          <div class="into-btn" @click="toPage">
            <div class="icon-right">
              <i class="el-icon-right"></i>
            </div>
            <p>切换 登录学生端</p>
          </div>
        </div>
      </el-form>
    </div>
    <div class="bottom">
      <span>
        <img src="../../assets/images//ga.png" alt />
      </span>
      <a
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        style="color:#fff"
      >浙ICP备2023042247号-3</a>
    </div>
  </div>
</template>

<script>
/**
 * @vue
 * @module views/login/index
 * @date   2025/3/20
 */
import { UserServer } from '@/api/api';
import {getInitConfig} from '@/config/config';
import Captcha from './Captcha.vue'
export default {
  name: 'Login',
  components: { Captcha },
  data () {
    const validateAccount = (rule, value, callback) => {
      if (value) {
        callback()
      } else {
        callback(new Error('请输入账号'))
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value) {
        callback()
      } else {
        callback(new Error('请输入密码'))
      }
    }
    const validateCaptcha = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'))
      } else if (value.length !== 4) {
        callback(new Error('验证码为4位字符'))
      } else if (!this.$refs.captchaComponent || !this.$refs.captchaComponent.validate(value)) {
        callback(new Error('验证码错误'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        account: '',
        password: '',
        captcha: ''
      },
      loginRules: {
        account: [{ required: true, trigger: 'blur', validator: validateAccount }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        captcha: [{ required: true, trigger: 'blur', validator: validateCaptcha }]
      },
      captchaCode: '',
      defaultState: false, // 标记登录信息是否由记住密码功能提供
      rePwd: '', // 记住的密码
      checked: false,
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      config: {}
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    initUser () {
      let user = null
      try {
        user = JSON.parse(doDecryptStr(localStorage.getItem('sw-login')))
      } catch (error) {
        console.log(error)
      }
      // 如果信息存在
      if (user) {
        this.loginForm.account = user.account
        this.loginForm.rePwd = user.password
        // 只是为了让密码输入框看起来有一个10位的密码
        if (this.rePwd) {
          this.password = '**********'
        }
        this.defaultState = true
        this.checked = true
      }
    },
    showPwd () {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    toPage () {
      const url = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/web/`;
      window.open(url, '_blank');
    },
    /**
     * 记住密码
     * @function addLogin
     */
    addLogin () {
      let data = {
        account: this.loginForm.account,
        password: this.loginForm.password
      }
      let info = JSON.stringify(data)
      localStorage.setItem('login', info)
    },
    /**
     * 清除保存的登录信息
     * @function deleteLogin
     */
    deleteLogin () {
      localStorage.removeItem('login');
    },
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          // 判断用户是否选择记住密码
          if (this.checked) {
            // 判断记住密码功能是否存在
            if (!this.defaultState) {
              // 记住密码
              this.addLogin();
            }
          } else {
            // 清除记住的内容
            this.deleteLogin();
          }
          this.loading = true
          let params = {
            account: this.loginForm.account
          }
          // 判断密码的来源
          if (this.defaultState) {
            params.password = this.rePwd
          } else {
            params.password = this.loginForm.password
          }
          UserServer.login(params).then(res => {
            const { code, message, data } = res;
            if (code === '0') {
              let path = '/system/chapter'
              this.$router.push({ path })
              localStorage.setItem('token', data.token);
              localStorage.setItem('userInfo', JSON.stringify(data));
            } else {
              this.loading = false
              this.$message.error(message)
              this.$refs.captchaComponent.refreshCaptcha()
              this.loginForm.captcha = ''
            }
          }).catch(() => {
            this.loading = false
            this.$message.error('登录失败!')
            this.$refs.captchaComponent.refreshCaptcha()
            this.loginForm.captcha = ''
          })
          // let path = '/system/chapter'
          // this.$router.push({ path })
          // this.$store.dispatch('user/login', this.loginForm).then(() => {
          //   this.$router.push({ path: this.redirect || '/' })
          //   this.loading = false
          // }).catch(() => {
          //   this.loading = false
          // })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  },
  created () {
    this.config = getInitConfig()
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #fff;
$light_gray: #fff;
$cursor: #283443;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .main {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 800px;
    border-width: 0px 0px 0px 1px;
    // border-style: solid;
    border-color: #FFFFFF;
    backdrop-filter: blur(20px);
    .el-checkbox {
      color: #000000;
    }
    .el-button--primary:hover {
      border-color: #3176FF;
    }
  }
  .el-input {
    display: inline-block;
    height: 44px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      height: 44px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }
  .el-form-item__content {
    display: flex;
    justify-content: left;
    align-items: center;
    border: 1px #FFFFFF solid;
    background: #FFFFFF;
    border-radius: 5px;
    padding-left: 10px;
    input {
    }
  }
  .el-form-item {
    color: #454545;
  }
  .el-form-item.active {
    // box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
  .el-input input:focus {
    box-shadow: none;
  }
  .captcha-img {
    position: absolute;
    right: 2px;
    top: 2px;
  }
}
</style>

<style lang="scss" scoped>
$bg:#2d3a4b;
$dark_gray:#889aa4;
$light_gray:#eee;
.bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  color: #fff;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 16px;
    margin-top: 3px;
    margin-right: 5px;
  }
}
.down {
  line-height: 65px;
  color: #3f88ff;
  font-style: italic;
  text-decoration: underline;
  font-size: 17px;
  font-weight: bold;
}
.login-container {
  min-height: 100%;
  width: 100%;
  overflow: hidden;
  background: url('~@/assets/images/bg.jpg');
  background-size:cover;
  .login-form {
    padding: 52px 80px;
    padding-top: 72px;
    overflow: hidden;
    width: 70%;
    position: absolute;
    top: 45%;
    transform: translate(10%, -50%);
    border-radius: 3px;
    display: flex;
    align-items: center;
    .left-text {
      display: flex;
      // margin: 0 auto;
      width: 30%;
      border-right: 1px solid #e5e5e5;
      margin-right:30px;
      p {
        width: 25px;
        font-size: 18px;
        font-weight: 600;
        margin-right: 10px;
        line-height: 30px;
      }
    }
    .right-content {
      width: 100%;
      .account, .password {
        width: 15px;
        height: 15px;
      }
    }
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .ul {
    list-style: none;
    background: rgba(255, 255, 255, 0.9);
    width: 182px;
    height: 30px;
    line-height: 30px;
    border-radius: 3px;
    box-sizing: content-box;
    padding: 2px 1px;
    position: absolute;
    top: 74px;
    right: 73px;
    z-index: 10;
    li {
      display: inline-block;
    }
  }
  .into-btn {
    width: 103px;
    margin: 0 auto;
    margin-top: 30px;
    color: #FFFFFF;
    cursor: pointer;
    .icon-right {
      width: 32px;
      height: 32px;
      margin: 0 auto;
      line-height: 32px;
      border-radius: 50%;
      border: 1px solid #FFFFFF;
      i {
        font-size: 16px;
      }
    }
    p {
      margin-top: 8px;
      font-size: 14px;
      text-shadow: 0px 2px 10px rgba(25, 45, 144, 0.3);
    }
  }
  .btn {
    width:100%;
    height:48px;
    border-radius: 4px;
    margin-bottom:16px;
    background: #3176FF;
    border-color:#3176FF;
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue